(function () {
  function setProductFormError(form, message) {
    var productForm = form.closest('product-form');
    var wrapper = productForm && productForm.querySelector('.product-form__error-message-wrapper');
    var text = wrapper && wrapper.querySelector('.product-form__error-message');
    if (!wrapper || !text) return;
    text.textContent = message || '';
    wrapper.toggleAttribute('hidden', !message);
  }

  function setSubmitLoading(form, loading) {
    var button = form.querySelector('[type="submit"][name="add"]');
    if (!button) return;

    if (loading) {
      button.dataset.lovelyWasDisabled = button.disabled ? 'true' : 'false';
      button.disabled = true;
      button.classList.add('loading');
      var spinner = button.querySelector('.loading__spinner');
      if (spinner) spinner.classList.remove('hidden');
      return;
    }

    button.disabled = button.dataset.lovelyWasDisabled === 'true';
    button.classList.remove('loading');
    var existingSpinner = button.querySelector('.loading__spinner');
    if (existingSpinner) existingSpinner.classList.add('hidden');
    delete button.dataset.lovelyWasDisabled;
  }

  function syncCard(input) {
    var card = input && input.closest('[data-lovely-addon-card]');
    if (!card) return;

    card.classList.toggle('is-selected', input.checked);
    var modalSelectButton = card.querySelector('[data-lovely-addon-modal-select]');
    if (modalSelectButton) {
      modalSelectButton.textContent = input.checked ? 'Selected' : 'Add this item';
      modalSelectButton.setAttribute('aria-pressed', input.checked ? 'true' : 'false');
      modalSelectButton.classList.toggle('is-selected', input.checked);
    }
  }

  function updateVariant(select) {
    var card = select.closest('[data-lovely-addon-card]');
    if (!card) return;

    var input = card.querySelector('[data-lovely-product-addon]');
    var option = select.options[select.selectedIndex];
    if (!input || !option || option.disabled) return;

    card.querySelectorAll('[data-lovely-addon-variant]').forEach(function (otherSelect) {
      if (otherSelect !== select) otherSelect.value = option.value;
    });

    input.dataset.lovelyAddon = option.value;
    var productTitle = input.dataset.lovelyAddonProductTitle || '';
    var variantTitle = option.dataset.variantTitle || '';
    input.dataset.lovelyAddonTitle =
      variantTitle && variantTitle !== 'Default Title' ? productTitle + ' - ' + variantTitle : productTitle;

    var price = card.querySelector('[data-lovely-addon-price]');
    if (price && option.dataset.variantPrice) price.textContent = option.dataset.variantPrice;
    var modalPrice = card.querySelector('[data-lovely-addon-modal-price]');
    if (modalPrice && option.dataset.variantPrice) modalPrice.textContent = option.dataset.variantPrice;

    var image = card.querySelector('.lovely-product-addons__image');
    if (image && option.dataset.variantImage) {
      image.src = option.dataset.variantImage;
      image.removeAttribute('srcset');
    }

    var modalImage = card.querySelector('.lovely-addon-modal__image');
    if (modalImage && option.dataset.variantLargeImage) {
      modalImage.src = option.dataset.variantLargeImage;
      modalImage.removeAttribute('srcset');
      card.querySelectorAll('[data-lovely-addon-modal-thumbnail]').forEach(function (thumbnail) {
        thumbnail.classList.toggle('is-active', thumbnail.dataset.imageSrc === option.dataset.variantLargeImage);
      });
    }

    input.checked = true;
    syncCard(input);
  }

  function closeLovelyAddonModal(dialog) {
    if (!dialog) return;
    if (dialog.open && typeof dialog.close === 'function') {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }
    document.documentElement.classList.remove('lovely-addon-modal-open');
  }

  function collectAddons(form) {
    var addons = [];
    var persInput = form.querySelector('.lovely-personalize__input');
    var persWrap = form.querySelector('.lovely-personalize');
    if (persInput && persInput.value.trim() && persWrap && persWrap.dataset.lovelyAddon) {
      addons.push({
        id: persWrap.dataset.lovelyAddon,
        type: 'personalisation',
        title: 'Personalisation',
        quantityMode: 'match-parent',
      });
    }

    var gift = form.querySelector('.lovely-giftwrap__check');
    if (gift && gift.checked && gift.dataset.lovelyAddon) {
      addons.push({
        id: gift.dataset.lovelyAddon,
        type: 'gift-wrap',
        title: 'Gift wrap',
        quantityMode: 'match-parent',
      });
    }

    form.querySelectorAll('[data-lovely-product-addon]:checked').forEach(function (input) {
      if (!input.dataset.lovelyAddon) return;
      addons.push({
        id: input.dataset.lovelyAddon,
        type: 'product-addon',
        title: input.dataset.lovelyAddonTitle || 'Add-on',
        quantityMode: input.dataset.lovelyAddonQuantityMode === 'match-parent' ? 'match-parent' : 'once',
      });
    });

    return addons;
  }

  document.addEventListener('change', function (event) {
    if (event.target.matches('[data-lovely-product-addon]')) syncCard(event.target);
    if (event.target.matches('[data-lovely-addon-variant]')) updateVariant(event.target);
  });

  document.addEventListener('click', function (event) {
    var openButton = event.target.closest('[data-lovely-addon-modal-open]');
    if (openButton) {
      var dialog = document.getElementById(openButton.getAttribute('aria-controls'));
      if (!dialog) return;
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
      document.documentElement.classList.add('lovely-addon-modal-open');
      var closeButton = dialog.querySelector('[data-lovely-addon-modal-close]');
      if (closeButton) closeButton.focus();
      return;
    }

    var closeButton = event.target.closest('[data-lovely-addon-modal-close]');
    if (closeButton) {
      closeLovelyAddonModal(closeButton.closest('[data-lovely-addon-modal]'));
      return;
    }

    var thumbnail = event.target.closest('[data-lovely-addon-modal-thumbnail]');
    if (thumbnail) {
      var thumbnailDialog = thumbnail.closest('[data-lovely-addon-modal]');
      var modalImage = thumbnailDialog && thumbnailDialog.querySelector('.lovely-addon-modal__image');
      if (modalImage && thumbnail.dataset.imageSrc) {
        modalImage.src = thumbnail.dataset.imageSrc;
        modalImage.alt = thumbnail.dataset.imageAlt || '';
        modalImage.removeAttribute('srcset');
      }
      thumbnailDialog.querySelectorAll('[data-lovely-addon-modal-thumbnail]').forEach(function (item) {
        item.classList.toggle('is-active', item === thumbnail);
      });
      return;
    }

    var modalSelectButton = event.target.closest('[data-lovely-addon-modal-select]');
    if (modalSelectButton) {
      var card = modalSelectButton.closest('[data-lovely-addon-card]');
      var input = card && card.querySelector('[data-lovely-product-addon]');
      if (input) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      closeLovelyAddonModal(modalSelectButton.closest('[data-lovely-addon-modal]'));
      return;
    }

    if (event.target.matches('[data-lovely-addon-modal]')) {
      closeLovelyAddonModal(event.target);
    }
  });

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.getAttribute) return;
      if ((form.getAttribute('action') || '').indexOf('/cart/add') === -1) return;

      var addons = collectAddons(form);
      if (!addons.length) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      var mainIdInput = form.querySelector('[name="id"]');
      var mainId = mainIdInput && mainIdInput.value;
      if (!mainId) return;

      var quantityInput = form.elements && form.elements.namedItem('quantity');
      var quantity = parseInt(quantityInput && quantityInput.value, 10) || 1;
      var properties = {};
      Array.prototype.forEach.call(form.elements || [], function (control) {
        if (!control.name || control.disabled) return;
        if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
        var match = control.name.match(/^properties\[(.+)\]$/);
        if (match && control.value) properties[match[1]] = control.value;
      });

      var productAddonTitles = addons
        .filter(function (addon) {
          return addon.type === 'product-addon';
        })
        .map(function (addon) {
          return addon.title;
        });
      if (productAddonTitles.length) properties['Add-ons'] = productAddonTitles.join(', ');

      var addonUid = 'lovely-' + Date.now() + '-' + Math.random().toString(36).slice(2);
      properties._lovely_addon_uid = addonUid;

      var items = [{ id: parseInt(mainId, 10), quantity: quantity, properties: properties }];
      addons.forEach(function (addon) {
        items.push({
          id: parseInt(addon.id, 10),
          quantity: addon.quantityMode === 'match-parent' ? quantity : 1,
          properties: {
            _lovely_addon: addon.type,
            _lovely_addon_uid: addonUid,
            _lovely_addon_for: mainId,
            _lovely_addon_title: addon.title,
            _lovely_addon_quantity_mode: addon.quantityMode,
          },
        });
      });

      var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      var sections =
        cart && cart.getSectionsToRender
          ? cart.getSectionsToRender().map(function (section) {
              return section.section || section.id;
            })
          : [];

      setProductFormError(form, '');
      setSubmitLoading(form, true);

      var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: items,
          sections: sections,
          sections_url: window.location.pathname,
        }),
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok || data.status) throw new Error(data.description || data.message || 'Could not add this item.');
            return data;
          });
        })
        .then(function (response) {
          if (cart && cart.renderContents) {
            try {
              cart.renderContents(response);
              if (cart.open) cart.open();
            } catch (renderError) {
              window.location.href = (window.routes && window.routes.cart_url) || '/cart';
            }
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          }
        })
        .catch(function (error) {
          setProductFormError(form, error.message || 'Could not add this item. Please try again.');
        })
        .finally(function () {
          setSubmitLoading(form, false);
        });
    },
    true
  );

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-lovely-product-addon]').forEach(syncCard);
    document.querySelectorAll('[data-lovely-addon-modal]').forEach(function (dialog) {
      dialog.addEventListener('close', function () {
        document.documentElement.classList.remove('lovely-addon-modal-open');
      });
    });
  });
})();
